/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetMediaExportJobsDownloadUrlQueryResponse, WebAppGetMediaExportJobsDownloadUrlPathParams, WebAppGetMediaExportJobsDownloadUrl401, WebAppGetMediaExportJobsDownloadUrl403, WebAppGetMediaExportJobsDownloadUrl404 } from "../models/WebAppGetMediaExportJobsDownloadUrl";

export function getWebAppGetMediaExportJobsDownloadUrlUrl(id: WebAppGetMediaExportJobsDownloadUrlPathParams["id"]) {
  const res = { method: 'GET', url: `/web-app/v1/export-jobs/${id}/download-url` as const }
  return res
}

/**
 * @description Returns a signed URL to download the exported file for a completed job.
 * @summary Get signed download URL
 * {@link /web-app/v1/export-jobs/:id/download-url}
 */
export async function webAppGetMediaExportJobsDownloadUrl(id: WebAppGetMediaExportJobsDownloadUrlPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<WebAppGetMediaExportJobsDownloadUrlQueryResponse, ResponseErrorConfig<WebAppGetMediaExportJobsDownloadUrl401 | WebAppGetMediaExportJobsDownloadUrl403 | WebAppGetMediaExportJobsDownloadUrl404>, unknown>({ method : "GET", url : getWebAppGetMediaExportJobsDownloadUrlUrl(id).url.toString(), ... requestConfig })
  return res.data
}